// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");

function empty(param) {
  return {
          id: undefined,
          operator: "in",
          value: /* [] */0,
          dataField: DataField$ReactHooksTemplate.empty(),
          destroy: false
        };
}

function id(t) {
  return t.id;
}

function value(t) {
  return t.value;
}

function dataField(t) {
  return t.dataField;
}

function operator(t) {
  return t.operator;
}

function destroy(t) {
  return t.destroy;
}

function isvalidDatarestriction(t) {
  if (List.length(t.value) < 1) {
    return {
            id: t.id,
            operator: t.operator,
            value: t.value,
            dataField: t.dataField,
            destroy: true
          };
  } else {
    return {
            id: t.id,
            operator: t.operator,
            value: t.value,
            dataField: t.dataField,
            destroy: false
          };
  }
}

function setDataField(t, dataField) {
  return {
          id: t.id,
          operator: t.operator,
          value: t.value,
          dataField: dataField,
          destroy: t.destroy
        };
}

function setValue(t, value) {
  return {
          id: t.id,
          operator: t.operator,
          value: value,
          dataField: t.dataField,
          destroy: t.destroy
        };
}

function setDestroy(t, destroy) {
  return {
          id: t.id,
          operator: t.operator,
          value: t.value,
          dataField: t.dataField,
          destroy: destroy
        };
}

function decode(json) {
  return {
          id: Json_decode.field("id", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          operator: Json_decode.field("operator", Json_decode.string, json),
          value: Json_decode.field("value", (function (param) {
                  return Json_decode.list(Json_decode.string, param);
                }), json),
          dataField: Json_decode.field("data_field", DataField$ReactHooksTemplate.decode, json),
          destroy: false
        };
}

function encode(t) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "operator",
                  t.operator
                ],
                tl: {
                  hd: [
                    "value",
                    Json_encode.list((function (prim) {
                            return prim;
                          }), t.value)
                  ],
                  tl: {
                    hd: [
                      "data_field_id",
                      Json_encode.nullable((function (prim) {
                              return prim;
                            }), DataField$ReactHooksTemplate.id(t.dataField))
                    ],
                    tl: {
                      hd: [
                        "_destroy",
                        t.destroy
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              }
            });
}

exports.id = id;
exports.value = value;
exports.dataField = dataField;
exports.operator = operator;
exports.destroy = destroy;
exports.empty = empty;
exports.setDataField = setDataField;
exports.setValue = setValue;
exports.setDestroy = setDestroy;
exports.decode = decode;
exports.encode = encode;
exports.isvalidDatarestriction = isvalidDatarestriction;
/* DataField-ReactHooksTemplate Not a pure module */
